import { useMutation } from '@tanstack/react-query';
import { postReminderUsers } from './requests';

const useRemindUsers = () =>
  useMutation({
    mutationFn: postReminderUsers,
  });

export default useRemindUsers;
